import React from 'react';
import { FormattedMessage } from 'react-intl/dist';

function FurtherAction ({ data, onCTAHandler }) {

    const { btnText, processedParagraphText } = data;

    return (data &&
        <div className="gray-border-box gi-panel" id="auto-further-action">
            <div className="grid-row">
                <h4 className="" id="further-action-header">
                    <FormattedMessage id='further_action.paragraph_header' />
                </h4>
            </div>
            <div className="grid-row">
                <p id="further-action-txt">
                    { processedParagraphText }
                </p>
            </div>
            {btnText &&
            <div className="grid-row">
                <div className="grid-col-12">
                    <div className="buttons-group text-right">
                        <button
                            type="button"
                            dataAutomationId={btnText}
                            id="further-action-btn"
                            className="usa-button gi-button gi-button__primary"
                            onClick={ () => onCTAHandler({ data }) }
                        >
                            <FormattedMessage id={btnText} />
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>
    );
}

export default FurtherAction;